import Vue from "vue";

import {
  getLedgerValutes,
  addLedgerValute,
  deleteLedgerValute,
  editLedgerValute
} from "@/api";
//
export default {
  namespaced: true,

  state: {
    ledgerValutes: {},
    page: 1,
    limit: 5,
    sort: "-_id",
    loading: true
  },

  mutations: {
    setLedgerValutes(state, ledgerValutes) {
      state.ledgerValutes = ledgerValutes;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async getLedgerValutes(store, payload = {}) {
      store.commit("setLoading", true);
      const resp = await getLedgerValutes({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort
      });
      if (resp.data.status) {
        const res = {
          ...resp.data.result,
          docs: resp.data.result.docs.map(doc => {
            return {
              ...doc,
              isNew: doc._id === payload.newId
            };
          })
        };
        store.commit("setLedgerValutes", res);
        store.commit("setLoading", false);
        return resp.data.result;
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.ledgerValutes.totalPages &&
        store.state.ledgerValutes.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getLedgerValutes");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getLedgerValutes");
      }
    },
    async addLedgerValute(store, ledgerValute) {
      const resp = await addLedgerValute(ledgerValute);
      if (resp.data.status) {
        await store.dispatch("getLedgerValutes", {
          newId: resp.data.result._id
        });
        return resp;
      }
    },
    async editLedgerValute(store, { id, ledgerValute }) {
      const resp = await editLedgerValute(id, ledgerValute);
      if (resp.data.status) {
        await store.dispatch("getLedgerValutes", {
          newId: resp.data.result._id
        });
        return resp;
      }
    },
    async deleteLedgerValute(store, id) {
      const resp = await deleteLedgerValute(id);
      if (resp.data.status) {
        await store.dispatch("getLedgerValutes");
        return resp;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerValutes.js